import "./assets/js/contact";

import "./assets/css/contact.less";



// WEBPACK FOOTER //
// ./src/contact.js